import { writable } from "svelte/store";
import { Role } from '@briefmarken_katalog/types'

export interface User {
  id: string;
  email: string;
  role: Role;
  token: string;
  name?: string;
}

function createStore()
{
  let { set, update, subscribe } = writable<User | null>(null);
  const promises = new Set();
  return {
    subscribe,
    update,
    set(value: User | null) {
      set(value);
      if (value != null)
      {
        promises.forEach((resolve: any) => {
          resolve();
        })
      }
    },
    waitForUpdate() {
      return new Promise<void>((resolve) => promises.add(resolve));
    }
  }
}

export const user = createStore();

function decodeJwtPayload(token: string): { id: string; email: string; role: Role; name?: string } | null {
  try {
    const parts = token.split(".");
    if (parts.length < 3) return null;
    // The payload is base64url-encoded UTF-8. atob() rejects the '-'/'_' alphabet and
    // returns a Latin-1 binary string, which would mangle umlauts, so translate the
    // alphabet first and decode the raw bytes as UTF-8.
    const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const bin = atob(b64.padEnd(Math.ceil(b64.length / 4) * 4, '='));
    const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    return null;
  }
}

const token = localStorage.getItem("jwt");
if (token) {
  const payload = decodeJwtPayload(token);
  if (payload) {
    user.set({ id: payload.id, email: payload.email, role: payload.role, token, ...(payload.name ? { name: payload.name } : {}) });
  } else {
    localStorage.removeItem("jwt");
  }
}

export function login(jwt: string) {
  localStorage.setItem("jwt", jwt);
  const payload = decodeJwtPayload(jwt);
  if (payload) {
    user.set({ id: payload.id, email: payload.email, role: payload.role, token: jwt, ...(payload.name ? { name: payload.name } : {}) });
  }
}

export function logout() {
  localStorage.removeItem("jwt");
  user.set(null);
}

let _doLogin: () => Promise<string> = () => Promise.reject(new Error('doLogin not initialized'));

export function setDoLogin(fn: () => Promise<string>) {
  _doLogin = fn;
}

export function doLogin(): Promise<string> {
  return _doLogin();
}
